import styled from 'styled-components';

import { BookmarkIcon } from '@genially/icons';

import { Variant } from './types';

interface VariantProps {
  $variant: Variant;
}

export const StyledBookmarkIcon = styled(BookmarkIcon)<VariantProps>(
  ({ theme: { color, size, transition }, $variant }) => ({
    color:
      $variant === Variant.FAVED
        ? color.content.info.default()
        : color.content.reversed.default(),
    minWidth: size.units(2),
    width: size.units(2),
    transition: transition.standard('color'),
  }),
);
export const Wrapper = styled.div<VariantProps>(
  ({ theme: { size, color }, $variant }) => ({
    '&:focus-visible': {
      outline: `2px solid ${color.border.accent.default()}`,
    },

    borderRadius: size.units(0.75),
    padding: `${size.units(0.5)} ${size.units(0.5)}`,
    backgroundColor: color.background.reversed.default(0.8),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    minWidth: size.units(3.25),
    whiteSpace: 'nowrap',

    '&:hover': {
      [StyledBookmarkIcon]: {
        color:
          $variant === Variant.FAVED
            ? color.content.info.contrast()
            : color.content.reversed.hover(),
      },
    },
  }),
);
